var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1833 22C18.563 22 16.9589 21.65 15.3712 20.95C13.7835 20.25 12.3413 19.2519 11.0444 17.9556C9.74763 16.6593 8.74948 15.2204 8.05 13.6389C7.35052 12.0574 7.00052 10.45 7 8.81667V8H11.5889L12.3083 11.9083L10.0917 14.1444C10.3769 14.65 10.6944 15.1296 11.0444 15.5833C11.3944 16.037 11.7704 16.4583 12.1722 16.8472C12.5481 17.2231 12.9599 17.583 13.4073 17.9268C13.8548 18.2706 14.3376 18.5913 14.8556 18.8889L17.1111 16.6333L21 17.4306V22H20.1833Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallicon);
export default __webpack_public_path__ + "static/media/Callicon.fdae28a4ac49db1f6e7aa2b449da6c6f.svg";
export { ForwardRef as ReactComponent };